import m6017 from '@/assets/models/6017.gltf'
import m6022 from '@/assets/models/6022.gltf'
import m7016 from '@/assets/models/7016.gltf'
import m7036 from '@/assets/models/7036.gltf'

const { title, topSections, models } = window.CONFIG || {
  title: '实习一：晶体宏观对称要素和晶体的对称分类',
  topSections: [{
    title: '目的要求：',
    paragrahps: [
      '1、通过对晶体模型的分析，加深对晶体对称、对称要素和对称操作的理解；',
      '2、根据对称要素的组合规律，在晶体模型上确定对称要素种类、数目及对称型；',
      '3、熟悉各晶系的对称特点，32 种对称型及晶体的对称分类。'
    ]
  }, {
    title: '步骤：',
    paragrahps: [
      '1、观察晶体上面、棱、角的重复规律，找出全部对称要素；',
      '2、根据对称要素组合规律检测核对；',
      '3、确定晶体所属对称型和晶族、晶系。'
    ]
  }],
  models: [
    { key: '6017', path: m6017 },
    { key: '6022', path: m6022 },
    { key: '7016', path: m7016 },
    { key: '7036', path: m7036 }
  ]
}

window.document.title = title

export default {
  title,
  topSections,
  models
}


// WEBPACK FOOTER //
// ./src/config.js